import React, { useContext, useEffect, useLayoutEffect } from "react"
import { Layout } from "antd"
import Sidebar from "./Sidebar"
import Main from "./Main"
import { TitleProvider } from "../../contexts/TitleContext"

import "./index.less"
import { Router } from "react-router-dom"
import { AuthActions, AuthContext } from "../../contexts/auth/AuthContext"
import history from "../../services/history"
import Auth from "../../pages/auth"
import { RENEW_TOKEN } from "../../rest-api/mutations/renewToken"
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint"
import Header2 from "./HeaderHome"
import { ThemeContext } from "../../contexts/ThemeContex"
import { useMutation } from "@tanstack/react-query"

export default function AppLayout() {
  const { authState, authDispatch } = useContext(AuthContext)
  const { themeState } = useContext(ThemeContext)
  const screens = useBreakpoint()
  const { mutate } = useMutation(RENEW_TOKEN, {
    onSuccess: (data) => {
      if (!data?.accessToken) {
        authDispatch({ type: AuthActions.SING_OUT })
        return
      }
      authDispatch({
        type: AuthActions.SIGN_IN,
        payload: {
          accessToken: data?.accessToken,
          refreshToken: data?.refreshToken,
        },
      })
    },
    onError: () => {
      authDispatch({ type: AuthActions.SING_OUT })
    },
  })

  useLayoutEffect(() => {
    if (
      !authState.accessToken ||
      !authState.refreshToken ||
      !authState.isAuthenticated
    ) {
      authDispatch({ type: AuthActions.SING_OUT })
      return
    }

    mutate({
      accessToken: authState.accessToken,
      refreshToken: authState.refreshToken,
    })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (themeState.currentTheme === "dark") {
      document.getElementById("darkBleck")?.classList.add("dark")
      // document.getElementsByClassName("ant-picker-panels" ).add("dark")
      // document.getElementsByClassName("ant-picker-panel-container" )?.classList.add("dark")
    } else {
      document.getElementById("darkBleck")?.classList.remove("dark")
    }
    document.getElementById("root")?.classList.add("apply-font")
  }, [themeState.currentTheme])

  return (
    <div className="WrapperProject">
      <Router history={history}>
        {authState.isAuthenticated ? (
          <TitleProvider>
            <Layout>
              <Sidebar />
              <Layout
                className={`site-layout ${
                  !screens.lg ? "site-layout-mobile" : ""
                }`}
              >
                <Header2 />
                <Main />
              </Layout>
            </Layout>
          </TitleProvider>
        ) : (
          <Auth />
        )}
      </Router>
    </div>
  )
}
